var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStubDefault = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20,4 C20.5522847,4 21,4.44771525 21,5 L21,16 C21,16.5522847 20.5522847,17 20,17 L1,17 C0.44771525,17 6.76353751e-17,16.5522847 0,16 L0,5 C-6.76353751e-17,4.44771525 0.44771525,4 1,4 L20,4 Z M19,6 L5,6 L5,13 L19,13 L19,6 Z",
  fill: "currentColor"
}))));
export default SvgStubDefault;